import { api } from '@/api/api-client.config.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';
import { PageType } from '@/@types/api.types.ts';

type GetPageResponse = {
  page: PageType | null;
};

const getPickemRules = (pickemId: number): Promise<GetPageResponse> =>
  api.get(`/admin/pages/key/pickem-${pickemId}`);

type UseGetPickemRulesQueryProps = {
  pickemId: number;
};

const getPickemRulesOptions = ({ pickemId }: UseGetPickemRulesQueryProps) => {
  return queryOptions({
    queryKey: ['getPickemRules', pickemId],
    queryFn: () => getPickemRules(pickemId),
  });
};

export const useGetPickemRulesQuery = ({
  pickemId,
}: UseGetPickemRulesQueryProps) => {
  return useQuery({
    ...getPickemRulesOptions({ pickemId }),
    select: (data) => data.page,
  });
};
